import React, { useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import { Calendar, ArrowRight } from 'lucide-react';
import UpComingView from './upcomingModal/UpComingView';
import logo from '../../../assets/logo/VJ-College-logo.png';
import '../upcomingEvents/Upcoming.css';

const config = require('../../../config.json');
const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const responsiveProps = {
  0: { items: 1 },
  1024: { items: 1 }
};

export default function LatestCalendar({ insights = [], loaded = true }) {
  const carouselRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleClose = () => setShowModal(false);

  const handleShow = (e, item, idx) => {
    if (e && e.preventDefault) e.preventDefault();
    setSelectedIndex(idx);
    setShowModal(true);
  };

  const handleImageError = (e) => {
    e.target.src = logo;
  };

  return (
    <div className="w-100 d-flex flex-column flex-grow-1">
      {/* Event Details Modal */}
      <Modal 
        show={showModal} 
        onHide={handleClose} 
        centered
        dialogClassName="vj-modal-dialog"
      >
        <Modal.Body className="p-0">
          <UpComingView 
            eventDetails={insights} 
            setIndex={setSelectedIndex} 
            index={selectedIndex} 
            handleClose={handleClose} 
          />
        </Modal.Body>
      </Modal>

      {/* Events Display */}
      {insights && insights.length > 0 ? (
        <div className="vj-events-carousel-wrap position-relative flex-grow-1 d-flex flex-column">
          <AliceCarousel
            ref={carouselRef}
            mouseTracking
            autoPlay
            infinite
            responsive={responsiveProps}
            animationDuration={1200}
            autoPlayInterval={6000}
            disableButtonsControls={insights.length <= 1}
            disableDotsControls={insights.length <= 1}
          >
            {insights.map((event, idx) => {
              const startDate = event.startDate ? new Date(event.startDate) : new Date();
              const day = isNaN(startDate.getDate()) ? '—' : startDate.getDate();
              const month = isNaN(startDate.getMonth()) ? 'EVENT' : months[startDate.getMonth()];
              const story = event.topStory || {};
              const imgUrl = story.timelineImage 
                ? `${config.s3.ImageinvokeURL}images/upcomingevents/${story.timelineImage}`
                : null;

              return (
                <div className="vj-event-slide p-0" key={idx}>
                  {/* Media wrapper with Date Badge */}
                  <div 
                    className="vj-card-media rounded-3 position-relative overflow-hidden cursor-pointer"
                    style={{ height: '345px' }}
                    onClick={(e) => handleShow(e, event, idx)}
                  >
                    <div className="vj-event-date-tag">
                      <span className="tag-day">{day}</span>
                      <span className="tag-month">{month}</span>
                    </div>

                    {imgUrl ? (
                      <img
                        src={imgUrl}
                        alt={story.timelineTitle || 'Event'}
                        onError={handleImageError}
                        style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center top' }}
                      />
                    ) : (
                      <div className="w-100 h-100 d-flex align-items-center justify-content-center bg-light">
                        <img src={logo} alt="Vidyajyoti" style={{ width: '80px', opacity: 0.6 }} />
                      </div>
                    )}
                  </div>

                  {/* Content & Action */}
                  <div className="vj-event-content pt-2.5 text-center d-flex flex-column align-items-center flex-grow-1">
                    <h5 
                      className="vj-event-title mb-1.5"
                      onClick={(e) => handleShow(e, event, idx)}
                      title={story.timelineTitle}
                      style={{ fontSize: '1.1rem', fontWeight: '700', color: '#1a2b56' }}
                    >
                      {story.timelineTitle || story.timelineHeader || 'Campus Event'}
                    </h5>
                    
                    {story.timelineDescription && (
                      <p className="vj-event-desc line-clamp-2 mb-2 text-muted small">
                        {story.timelineDescription}
                      </p>
                    )}

                    <div className="mt-auto pt-1 pb-1">
                      <button 
                        type="button" 
                        className="vj-btn-primary btn-sm"
                        onClick={(e) => handleShow(e, event, idx)}
                      >
                        Event Details <ArrowRight size={15} />
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </AliceCarousel>
        </div>
      ) : (
        <div className="vj-events-empty">
          <div className="vj-icon-badge mb-3" style={{ width: '56px', height: '56px' }}>
            <Calendar size={28} />
          </div>
          <h6 className="fw-bold text-dark mb-1">No Upcoming Events</h6>
          <p className="text-muted small mb-0">Check back soon for new lectures, seminars, and campus events.</p>
        </div>
      )}
    </div>
  );
}
